/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowVirtualWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowVirtualWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Connect Virtually!",
    "Virtual Workshop Awaits!",
    "Learn from Home Together!",
  ],
  title: "Virtual Workshop",
  description: "Organize an engaging virtual workshop.",
  longDescription:
    "Gather your friends for a virtual workshop! Choose a date, decide on topics to cover, and plan interactive activities!",
  emoji: "💻",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Virtual Workshop",
          emoji: "💻",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the virtual workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on topics to cover?",
            description: "What topics should we explore during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What topics should we consider?",
                emoji: "📚",
                completeAction: {
                  question: "Decide on tools needed?",
                  description:
                    "What tools should we gather for the virtual session?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "🛠",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Connect Online!",
    outroDescription:
      "Your virtual workshop plans are set! Enjoy the learning!",
  },
};
